import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { reelsShortsInfo } from "../../../SchemaInfo/info";
import { FcClapperboard, FcCompactCamera } from "react-icons/fc";
import { reelShortsSchema } from "../../../Schemas/Media And Marketing/reels_short";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useEffect } from "react";

const AddReelShorts = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [socialMedia, setSocialMedia] = useState([]);
  const navigate = useNavigate();

  const handelSubmit = (values) => {
    setLoading(true);
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("POST", `/reelshort/create-reel-short`, values, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Reel / short created successfully!");
          navigate(`/all-reel-shorts`);
        } else {
          Toast("error", "Error while creating reel / short");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  // Generate time slots (1 hour interval)
  const generateTimeSlots = () => {
    const times = [];
    for (let i = 0; i < 24; i++) {
      const hour = i.toString().padStart(2, "0");
      times.push(`${hour}:00`);
    }
    return times;
  };

  const timeSlots = generateTimeSlots();

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCompactCamera></FcCompactCamera> Reel / Short
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title ">Create Reel / Short</h2>
            </div>
            <Formik
              initialValues={reelsShortsInfo}
              validationSchema={reelShortsSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* <h3> Create a Reel / Short</h3>
                    <hr className=""></hr> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel / Short Branding Assets
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="shortBrandingAss"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Sudhir Devkar">Sudhir Devkar</option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                        </CustomSelect>

                        {props.touched.shortBrandingAss &&
                          props.errors.shortBrandingAss && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.shortBrandingAss}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Reel Type</label>
                      <div className="w-100 col">
                        <CustomSelect name="reelType" className="form-control">
                          <option value="">Select</option>
                          <option value="Podcast Clip">Podcast Clip </option>
                          <option value="Informative Clip">
                            Informative Clip
                          </option>
                          <option value="Standalone">Standalone</option>
                        </CustomSelect>

                        {props.touched.reelType && props.errors.reelType && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.reelType}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Raw Source / Script
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="rawSource"
                        ></CustomTextArea>
                        {props.touched.rawSource && props.errors.rawSource && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.rawSource}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <hr className=""></hr>
                    <h3> Edit Reel / Shorts</h3>
                    <hr className=""></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Editor Name
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="reelShortEditor">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Deadline</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="taskdedline"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel / Short Thumbnail
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "shortThumbnail",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.shortThumbnail &&
                          props.errors.shortThumbnail && (
                            <p className="text-danger">
                              {props.errors.shortThumbnail}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Reel First Draft File Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="reelFirstPath"
                        ></CustomInput>
                        {props.touched.reelFirstPath &&
                          props.errors.reelFirstPath && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.reelFirstPath}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className=""></hr>
                    <h3> Final Reels / Shorts</h3>
                    <hr className=""></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel / Short Final Footage Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="shortDriveLink"
                        ></CustomInput>
                        {props.touched.shortDriveLink &&
                          props.errors.shortDriveLink && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.shortDriveLink}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel Publish Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="publishDate"
                        ></CustomInput>
                        {props.touched.publishDate &&
                          props.errors.publishDate && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.publishDate}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel Publish Time
                      </label>

                      <div className="w-100 col">
                        <select
                          name="publishTime"
                          className="form-control"
                          value={props.values.publishTime}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        >
                          <option value="">Select Time</option>

                          {Array.from({ length: 24 }, (_, i) => {
                            let hour = i % 12 || 12;
                            let ampm = i < 12 ? "AM" : "PM";
                            let time = `${hour}:00 ${ampm}`;

                            return (
                              <option key={i} value={time}>
                                {time}
                              </option>
                            );
                          })}
                        </select>

                        {props.touched.publishTime &&
                          props.errors.publishTime && (
                            <p className="text-danger">
                              {props.errors.publishTime}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Reel / Short Title
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="shortTitle"
                        ></CustomInput>
                        {props.touched.shortTitle &&
                          props.errors.shortTitle && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.shortTitle}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Reel / Short Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="shortDescription"
                        ></CustomTextArea>
                        {props.touched.shortDescription &&
                          props.errors.shortDescription && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.shortDescription}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Mark as Published (Upload proof)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "markAsPublished",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.markAsPublished &&
                          props.errors.markAsPublished && (
                            <p className="text-danger">
                              {props.errors.markAsPublished}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create New Reel / Short" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddReelShorts;
